var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenBarGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 -0.000366211H0.5C0.223858 -0.000366211 0 0.223491 0 0.499634V12.4996C0 12.7758 0.223858 12.9996 0.5 12.9996H1.5C1.77614 12.9996 2 12.7758 2 12.4996V0.499634C2 0.223491 1.77614 -0.000366211 1.5 -0.000366211Z",
    fill: "#3DA64F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.49963H3.5C3.22386 3.49963 3 3.72349 3 3.99963V12.4996C3 12.7758 3.22386 12.9996 3.5 12.9996H4.5C4.77614 12.9996 5 12.7758 5 12.4996V3.99963C5 3.72349 4.77614 3.49963 4.5 3.49963Z",
    fill: "#3DA64F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.99963H6.5C6.22386 6.99963 6 7.22349 6 7.49963V12.4996C6 12.7758 6.22386 12.9996 6.5 12.9996H7.5C7.77614 12.9996 8 12.7758 8 12.4996V7.49963C8 7.22349 7.77614 6.99963 7.5 6.99963Z",
    fill: "#3DA64F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.49963H9.5C9.22386 3.49963 9 3.72349 9 3.99963V12.4996C9 12.7758 9.22386 12.9996 9.5 12.9996H10.5C10.7761 12.9996 11 12.7758 11 12.4996V3.99963C11 3.72349 10.7761 3.49963 10.5 3.49963Z",
    fill: "#3DA64F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 6.99963H12.5C12.2239 6.99963 12 7.22349 12 7.49963V12.4996C12 12.7758 12.2239 12.9996 12.5 12.9996H13.5C13.7761 12.9996 14 12.7758 14 12.4996V7.49963C14 7.22349 13.7761 6.99963 13.5 6.99963Z",
    fill: "#3DA64F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBarGraph);
export default __webpack_public_path__ + "static/media/greenBarGraph.2733e8a654ddea48587faafe271838cc.svg";
export { ForwardRef as ReactComponent };